// CSS Modules - component class name prefix: ShopPageHeader__

<template>
  <div :class="[{ ShopPageHeader__sticky__margin: sticky }, $style.container]">
    <div :class="$style.navMeta">
      <div class="columns is-gapless is-mobile is-vcentered">
        <div
          :class="[
            $style.homeTextLink,
            'column is-one-quarter-tablet is-one-fifth-desktop'
          ]"
        >
          <a href="#">WIKA Online-Shop</a>
        </div>
        <div class="column is-three-quarters-tablet is-four-fifths-desktop">
          <div class="columns is-gapless is-mobile is-vcentered">
            <div
              :class="[
                $style.switcher,
                'column is-one-third-mobile is-one-third-tablet is-one-quarter-desktop'
              ]"
            >
              <div :class="$style.countrySwitcher">
                <ShopCountrySwitcher
                  :config="{
                    currentRegion: 'Europa',
                    currentCountry: 'Deutschland',
                    title: 'WIKA Online-Shop',
                    flag:
                      'https://shop.wika.com/media/10__images/system/flag_small/de.png'
                  }"
                />
              </div>
            </div>
            <div :class="[$style.search, 'column is-one-quarter-desktop']">
              <div :class="$style.desktopSearch">
                <ElasticSearch :config="searchConfig" />
              </div>
            </div>
            <div
              :class="[
                $style.loginLink,
                'column is-one-third-mobile is-one-third-tablet is-one-quarter-desktop'
              ]"
            >
              <ShopLogin :config="loginConfig" />
            </div>
            <div
              :class="[
                $style.cartLink,
                'column is-one-third-mobile is-one-third-tablet is-one-quarter-desktop'
              ]"
            >
              <ShopCart :config="cartConfig" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="[{ ShopPageHeader__sticky: sticky }, $style.navMain]">
      <div class="columns is-mobile is-multiline is-vcentered">
        <div :class="[$style.homeLink, 'column']">
          <a title="WIKA" href="#">
            <img src="../../assets/logo_wika.png" alt="WIKA" />
          </a>
        </div>
        <div :class="[$style.desktopNav, 'column']">
          <MainMenu
            :isShop="true"
            :primaryLinks="primaryLinks"
            :secondaryLinks="secondaryLinks"
          />
        </div>
        <div :class="[$style.mobileSearch, 'column']">
          <ElasticSearch :config="searchConfig" />
        </div>
        <div :class="[$style.mobileNav, 'column']">
          <MobileMenu
            :isShop="true"
            :primaryLinks="primaryLinks"
            :secondaryLinks="secondaryLinks"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShopCountrySwitcher from "../ShopCountrySwitcher/ShopCountrySwitcher";
import MainMenu from "../MainMenu/MainMenu";
import MobileMenu from "../MobileMenu/MobileMenu";
import ElasticSearch from "../ElasticSearch/ElasticSearch";
import ShopCart from "../ShopCart/ShopCart";
import ShopLogin from "../ShopLogin/ShopLogin";

export default {
  name: "ShopPageHeader",
  components: {
    ShopCountrySwitcher,
    MainMenu,
    MobileMenu,
    ElasticSearch,
    ShopCart,
    ShopLogin
  },
  data() {
    return {
      searchConfig: {
        headerSearch: true,
        isShop: true,
        submitUrl: "",
        placeholder: "Suche"
      },
      sticky: false,
      stickyPosition: 40,
      loginConfig: {
        loginText: "Anmelden",
        loggedInText: "Mein Konto",
        registrationText: "Registrieren",
        registrationUrl:
          "http://localhost:6006/iframe.html?id=8-shop-shop-system-page--component&actionType=register",
        passwordText: "Passwort vergessen?",
        passwordUrl:
          "http://localhost:6006/iframe.html?id=8-shop-shop-system-page--component&actionType=forgotpassword",
        passwordInput: "Passwort",
        emailInput: "E-Mail-Adresse",
        warningHeadline: "Hinweis",
        warningText:
          "Ihre Anmeldung war nicht erfolgreich. Bitte überprüfen Sie Ihre Daten.",
        shopBaseUrl: "https://shop-system-qa.wika.de/eu/l_de",
        homepage:
          "http://localhost:6006/iframe.html?id=8-shop-shop-start-page--component&viewMode=story",
        redirectUrl:
          "http://localhost:6006/iframe.html?id=8-shop-shop-system-page--component&actionType=history",
        loginMenu: [
          {
            title: "Übersicht",
            url:
              "http://localhost:6006/iframe.html?id=8-shop-shop-system-page--component&actionType=account"
          },
          {
            title: "Benutzer-/Zugangsdaten",
            url:
              "http://localhost:6006/iframe.html?id=8-shop-shop-system-page--component&actionType=accountEdit"
          },
          {
            title: "Adressverwaltung",
            url:
              "http://localhost:6006/iframe.html?id=8-shop-shop-system-page--component&actionType=address"
          },
          {
            title: "Meine Bestellung(en)",
            url:
              "http://localhost:6006/iframe.html?id=8-shop-shop-system-page--component&actionType=history"
          },
          { title: "Abmelden", url: "logout" }
        ]
      },
      cartConfig: {
        selectOptionMax: 25,
        itemNumber: "Artikelnummer",
        headline: "Zum Warenkorb hinzugefügt",
        buttonText: "Zum Warenkorb",
        pricePerItem: "Preis (Stück)",
        currency: "€",
        currencyPosition: "%v %s",
        decimalSep: ",",
        thousandSep: ".",
        precisionValue: "2",
        quantity: "Anzahl",
        tax: "zzgl. MwSt.",
        shippingText: "Versand",
        shippingUrl: "/service_info_shipping_shop_de_de.WIKA",
        totalPrice: "Gesamtbetrag",
        shopCartUrl:
          "http://localhost:6006/iframe.html?id=8-shop-shop-system-page--component&actionType=showcart"
      },
      primaryLinks: [
        {
          title: "Druck",
          id: "1",
          subNav: [
            {
              id: "1",
              title: "Manometer",
              url:
                "http://shop-qa.wika.dev.intern.etecture.de/de-de/manometer-2.WIKA"
            },
            {
              id: "2",
              title: "Digital Manometer",
              url:
                "http://shop-qa.wika.dev.intern.etecture.de/de-de/digitalmanometer.WIKA"
            },
            {
              id: "3",
              title: "Volumenstromsensoren",
              url:
                "http://shop-qa.wika.dev.intern.etecture.de/de-de/volumenstromsensoren.WIKA"
            }
          ],
          url: "http://shop-qa.wika.dev.intern.etecture.de/de-de/druck.WIKA"
        },
        {
          title: "Temperatur",
          id: "2",
          subNav: [
            {
              id: "1",
              title: "Widerstandsthermometer",
              url:
                "http://shop-qa.wika.dev.intern.etecture.de/de-de/widerstandsthermometer.WIKA"
            },
            {
              id: "2",
              title: "Zeigerthermometer",
              url:
                "http://shop-qa.wika.dev.intern.etecture.de/de-de/zeigerthermometer.WIKA"
            }
          ],
          url:
            "http://shop-qa.wika.dev.intern.etecture.de/de-de/temperatur.WIKA"
        },
        {
          title: "F\u00fcllstand",
          id: "3",
          subNav: [
            {
              id: "1",
              title: "Optoelektronische Schalter",
              url:
                "http://shop-qa.wika.dev.intern.etecture.de/de-de/optoelektronische-schalter.WIKA"
            },
            {
              id: "2",
              title: "Pegelsonden",
              url:
                "http://shop-qa.wika.dev.intern.etecture.de/de-de/pegelsonden.WIKA"
            }
          ],
          url:
            "http://shop-qa.wika.dev.intern.etecture.de/de-de/fuellstand.WIKA"
        },
        {
          title: "Durchfluss",
          id: "4",
          subNav: [
            {
              id: "1",
              title: "Prim\u00e4re Durchflusselemente",
              url:
                "http://shop-qa.wika.dev.intern.etecture.de/de-de/primaere-durchflusselemente.WIKA"
            },
            {
              id: "2",
              title: "Str\u00f6mugsschalter",
              url:
                "http://shop-qa.wika.dev.intern.etecture.de/de-de/stroemungsschalter.WIKA"
            }
          ],
          url:
            "http://shop-qa.wika.dev.intern.etecture.de/de-de/durchfluss.WIKA"
        },
        {
          title: "Kalibrierung",
          id: "5",
          subNav: [
            {
              id: "1",
              title: "Digitalmanometer",
              url:
                "http://shop-qa.wika.dev.intern.etecture.de/de-de/digitalmanometer-2.WIKA"
            },
            {
              id: "2",
              title: "Hand-helds",
              url:
                "http://shop-qa.wika.dev.intern.etecture.de/de-de/hand-helds.WIKA"
            }
          ],
          url:
            "http://shop-qa.wika.dev.intern.etecture.de/de-de/kalibrierung.WIKA"
        },
        {
          id: "6",
          title: "Kraft",
          url:
            "http://shop-qa.wika.dev.intern.etecture.de/de-de/industrial-2.WIKA"
        }
      ],
      secondaryLinks: [
        {
          id: "1",
          title: "Ihre Vorteile",
          url: "http://www.google.com",
          subNav: [
            { id: "1", title: "WIKA Gruppe", url: "http://www.google.com" },
            { id: "2", title: "WIKA Deutschland", url: "#" },
            { id: "3", title: "Neuheiten & Messen", url: "#" }
          ]
        },
        {
          id: "2",
          title: "Zahlung",
          url: "#",
          subNav: [
            { id: "1", title: "Arbeitgeber", url: "#" },
            { id: "2", title: "Schüler", url: "#" },
            { id: "3", title: "Studenten", url: "#" },
            { id: "4", title: "Berufseinsteiger", url: "#" },
            { id: "5", title: "Berufserfahrene", url: "#" },
            { id: "6", title: "Stellenmarkt", url: "#" },
            { id: "7", title: "Personalmessen", url: "#" }
          ]
        },
        {
          id: "3",
          title: "Versand",
          url: "#",
          subNav: [
            { id: "1", title: "Ansprechpartner", url: "#" },
            { id: "2", title: "Kontaktformular", url: "#" },
            { id: "3", title: "Ihr Feedback", url: "#" },
            { id: "4", title: "Chatten Sie mit uns", url: "#" },
            { id: "5", title: "Anfahrt", url: "#" },
            { id: "6", title: "WIKA weltweit", url: "#" }
          ]
        },
        {
          id: "4",
          title: "Häufige Fragen",
          url: "#",
          subNav: [
            { id: "1", title: "Ansprechpartner", url: "#" },
            { id: "2", title: "Kontaktformular", url: "#" },
            { id: "3", title: "Ihr Feedback", url: "#" },
            { id: "4", title: "Chatten Sie mit uns", url: "#" },
            { id: "5", title: "Anfahrt", url: "#" },
            { id: "6", title: "WIKA weltweit", url: "#" }
          ]
        }
      ]
    };
  },
  methods: {
    initScroll() {
      window.addEventListener("scroll", this.handleScroll);
    },
    handleScroll() {
      this.sticky = window.pageYOffset > this.stickyPosition;
    }
  },
  created() {
    this.initScroll();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style module lang="scss">
@import "./ShopPageHeader.scss";
</style>
